import axios from "axios";

export const getPayments = () => {
    return axios.get("Orders/PaymentMethods");
} 